export const idlFactory = ({ IDL }) => {
  const TopUpType = IDL.Variant({
    SNS: IDL.Null,
    Blackhole: IDL.Null,
    Manual: IDL.Null,
  })
  const CanisterInfo = IDL.Record({
    id: IDL.Principal,
    is_healthy: IDL.Bool,
    auto_topup: IDL.Bool,
    name: IDL.Text,
    topup_type: TopUpType,
    topup_amount: IDL.Nat,
    sns_root: IDL.Opt(IDL.Principal),
    cycles_left: IDL.Nat,
    min_cycles: IDL.Nat,
  })
  const Error = IDL.Variant({
    InvalidInput: IDL.Null,
    NotAllowed: IDL.Null,
    Duplicate: IDL.Null,
    NotBlackholed: IDL.Null,
    NotFound: IDL.Null,
    General: IDL.Null,
  })
  const TopUp = IDL.Record({
    topup_type: IDL.Opt(TopUpType),
    canister: IDL.Principal,
    timestamp: IDL.Nat64,
    amount: IDL.Nat,
  })
  const UserProfile = IDL.Record({
    enough_cycles: IDL.Bool,
    canisters: IDL.Vec(CanisterInfo),
  })
  const TopUpHistory = IDL.Record({ history: IDL.Vec(TopUp) })
  return IDL.Service({
    add_canister: IDL.Func([CanisterInfo], [IDL.Variant({ Ok: IDL.Text, Err: Error })], []),
    add_top_up_history: IDL.Func([TopUp], [IDL.Variant({ Ok: IDL.Text, Err: Error })], []),
    cycles_left: IDL.Func([], [IDL.Nat64], ['query']),
    delete_canister: IDL.Func([IDL.Principal], [IDL.Variant({ Ok: IDL.Text, Err: Error })], []),
    get_all_profiles: IDL.Func([], [IDL.Vec(IDL.Tuple(IDL.Principal, UserProfile))], ['query']),
    get_all_top_up_history: IDL.Func(
      [],
      [IDL.Vec(IDL.Tuple(IDL.Principal, TopUpHistory))],
      ['query']
    ),
    get_broken_canisters: IDL.Func(
      [],
      [IDL.Vec(IDL.Tuple(IDL.Principal, IDL.Vec(IDL.Principal)))],
      ['query']
    ),
    get_canister_controllers: IDL.Func(
      [IDL.Principal],
      [IDL.Variant({ Ok: IDL.Vec(IDL.Principal), Err: IDL.Text })],
      []
    ),
    get_profile: IDL.Func([IDL.Principal], [IDL.Opt(UserProfile)], ['query']),
    get_queue: IDL.Func([], [IDL.Vec(IDL.Tuple(IDL.Principal, IDL.Principal))], ['query']),
    get_top_up_history: IDL.Func([IDL.Principal], [IDL.Opt(TopUpHistory)], ['query']),
    update_canister_settings: IDL.Func(
      [
        IDL.Principal,
        IDL.Opt(IDL.Text),
        IDL.Opt(IDL.Nat),
        IDL.Opt(IDL.Nat),
        IDL.Opt(IDL.Bool),
        IDL.Opt(TopUpType),
      ],
      [IDL.Variant({ Ok: IDL.Text, Err: Error })],
      []
    ),
    update_enough_cycles: IDL.Func([IDL.Bool], [IDL.Variant({ Ok: IDL.Text, Err: Error })], []),
  })
}
export const init = ({ IDL }) => {
  return []
}
